import Vue from 'vue';
import Vuex from 'vuex';
import { mutations } from './mutations';
import getters from './getters';
import actions from './actions';
import product from './modules/product';
import activeProduct from './modules/activeProduct';

Vue.use(Vuex);
export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state:  {
    // newly created states
    defaultCropMarks: {},
    crop:             {
      isEnable: false,
      object:   null,
    },
    userInfo: {},
    // state For Svg Icons
    productSvg:           [],
    SVGCategories:        [],
    favouriteSizes:       [],
    selectedProduct:      {},
    selectedProductIndex: 0,
    selection:            {
      index:              [0],
      selectionCreatedBy: 'none',
    },
    CMYKColor:          [],
    AllNewPmsColors:    [],
    selectedPage:       0,
    leftPanelToShow:    'none',
    isAddNewImageModal: false,
    colorpicker:        {
      isopen: false,
      color:  '#0E0F10',
    },
    isimageopen:      false,
    isShapeModelOpen: false,
    bankPMSColor:     { bankId: '-1', bankName: '', bankPmsColorList: [] },
    productfontarray: [],
    baseImage:        '',
    productColor:     [],
    yourColor:        [],
    bankId:           'fde5ed9d-816f-43fd-89f3-97a542947193',
    userId:           '',
    addressBoxes:     [],
    housingLogos:     [{
      Type:   'Black',
      PdfUrl: 'https://www.bankmarketingcenter.com/protectedarea/images/202011/EHO.logo.pdf',
    },
    {
      Type:   'White',
      PdfUrl: 'https://www.bankmarketingcenter.com/protectedarea/images/202011/EHO.logo.white.pdf',
    }],
    ncuaLogos: [{
      Type:   'Black',
      PdfUrl: 'https://www.bankmarketingcenter.com/upload/banklogos/ncualogocreditUnion.pdf',
    },
    {
      Type:   'White',
      PdfUrl: 'https://www.bankmarketingcenter.com/upload/banklogos/ncualogowhitecreditUnion.pdf',
    }],
    fdicLogos: [{
      Type:   'Black',
      PdfUrl: 'https://www.bankmarketingcenter.com/protectedarea/images/202109/fdictext.pdf',
    },
    {
      Type:   'White',
      PdfUrl: 'https://www.bankmarketingcenter.com/upload/banklogos/fdictextwhite.pdf',
    }],
    orderItemId:             '',
    redirectUrl:             null,
    isSavedAndClosed:        false,
    undoRedoArrayListLength: 0,
    SaveApiMethod:           '',
    BaseUrl:                 '//dev2.wysiwyg.bankmarketingcenter.com',
    BMCInstance:             'bankmarketingcenter',
    boundingBoxHandle:       {
      ns: 1,
      ew: 1,
    },
    zoomLevel:            0,
    canvasScrollPosition: { top: 0, left: 0 },
    isUnitInInch:         true,
    displayQRCodeModal:   false,
    svgCategoryFilter:    '',
    displayPreviewModal:  false,
    displayAddVideoModal: false,
    displayAddAudioModal: false,
    isAudioTrimOn:        false,
    // previously used states by team ended
    // pageThumbnails:[],
    isLoaderVisible:      false,
    previewClicked:       '',
    displayHelpText:      true,
    copiedObjects:        [],
    isVideoModel:         false,
    submittedAs:         'image',
    isOpenBgRemoverModal: false,
    bgRemoverImagesList: [],
    timeLinePercentage: 0,
  },
  modules: {
    productModule: product,
    activeProduct,
  },
  getters,
  mutations,
  actions,

});
